const challengesList = {
  "challenges.list.empty": "¡No hay desafíos que mostrar!",
};

const challengeModal = {
  "challenges.challenge.finished.modal.title.improved": "¡Felicidades!",
  "challenges.challenge.finished.modal.title.completed": "¡Felicidades!",
  "challenges.challenge.finished.modal.title.failed": "¡Mejor suerte la próxima vez!",
  "challenges.challenge.finished.modal.body.improved": "Completaste el desafío y ganaste una nueva recompensa.",
  "challenges.challenge.finished.modal.body.completed": "Completaste el desafío y obtuviste {{ reward }}.",
  "challenges.challenge.finished.modal.body.failed": "No completaste el desafío esta vez.",
  "challenges.challenge.finished.modal.targets.title": "Alcanza los siguientes objetivos para obtener una mejor recompensa:",
  "challenges.challenge.finished.modal.targets.your-score": "Tu puntuación:",
  "challenges.challenge.finished.modal.targets.next-target": "Objetivo para la próxima recompensa:",
};

const challengeSection = {
  "challenges.section.view": "Ver",
  "challenges.section.join": "Unirse al desafío",
};

const challengeStatus = {
  'challenges.challenge.status.label': 'Estado',
  'challenges.challenge.status.null': 'No Iniciado',
  'challenges.challenge.status.not_started': 'No Iniciado',
  'challenges.challenge.status.completed': 'Completado',
  'challenges.challenge.status.failed': 'Fallido',
  'challenges.challenge.status.winner': 'Ganador',
};

const challengesPage = {
  "challenges.page.title": "Desafíos",
  "challenges.subheader.continue": "Continuar",
  "challenges.subheader.categories": "Explorar por Categoría",
  "challenges.subheader.drills": "Desafíos de Entrenamiento",
  "challenges.subheader.recently.played": "Jugados Recientemente",
  "challenges.promo.caption": "Desafío del Mes",
  "challenges.latest.caption": "Último Desafío",
  "challenges.fallback.career.caption": "¡Continúa la Carrera para avanzar a nuevas ligas y desbloquear Desafíos!",
  "challenges.fallback.demo.title": "Prueba",
  "challenges.fallback.demo.caption": "Durante tu prueba, tienes acceso a una selección curada de desafíos para ayudarte a comenzar.",
  "challenges.categories.all": "Todos",
  "challenges.list.active": "Activos",
  "challenges.list.archived": "Archivados",
};

const challengePage = {
  "challenges.challenge.page.title": "Desafío",
  "challenges.challenge.list.header": "Desafíos ({{ challenges }})",
  "challenges.challenge.page.join": "Unirse",
  "challenges.challenge.page.details": "Detalles",
  "challenges.challenge.page.scenarios": " escenarios",
  "challenges.challenge.page.has-ended": "Este desafío ha terminado",
  "challenges.challenge.page.ends-in": "Termina en {{ time }}",
  "challenges.challenge.page.not-started": "Este desafío no ha comenzado aún",
  "challenges.challenge.page.current.score": "Tu puntuación actual",
  "challenges.challenge.page.current.score.main.metric": "BYB IQ:",
  "challenges.challenge.page.rewards": "Recompensas",
  "challenges.challenge.page.leaderboard.title": "Clasificación",
  "challenges.challenge.page.leaderboard.top": "Clasificación (Top {{ count }})",
  "challenges.challenge.page.leaderboard.join": "Unirse",
  "challenges.challenge.page.leaderboard.see-all": "Ver todos",
  "challenges.challenge.page.leaderboard.no-data": "Ningún jugador ha completado este desafío aún",
  "challenges.challenge.page.description": "Descripción",
  "challenges.challenge.page.results.title": "Tus resultados",
  "challenges.challenge.page.results.see-all": "Ver todos los resultados",
  "challenges.challenge.page.results.error.description": "No se pudieron cargar los resultados del desafío",
};

const challengeCategoryPage = {
  "challenges.category.page.latest.challenge": "Último Desafío",
  "challenges.category.page.grid.title": "{{ count }} Desafíos",
};

const challengeReward = {
  "challenges.reward.target": "Objetivo: {{ target }} {{ metric }}",
  "challenges.reward.place": "{{ place }} lugar",
  "challenges.reward.not.ranked": "No clasificado",
  "challenges.reward.achieved.on": "Obtenido el {{ date }}",
  "challenges.reward.not.achieved": "Aún no obtenido",
  "challenges.reward.scarcity": "Obtenida por el {{ scarcity }}% de los jugadores que intentaron este desafío",
  "challenges.reward.best.iq": "{{ iq }} BYB IQ",
};

const challengeCard = {
  "challenges.card.tooltip.locked.rating": "Avanza en tu Carrera para desbloquear este Desafío",
  "challenges.card.tooltip.locked.demo": "Compra una suscripción Be Your Best para desbloquear este Desafío",
  "challenges.card.starts-in": "Comienza en {{ time }}",
  "challenges.card.ends-in": "Termina en {{ time }}",
  "challenges.card.has-ended": "Terminado",
  "challenges.play-challenge": "Jugar Desafío",
};

const challengeFilter = {
  "challenges.filter.title": "Filtrar",
  "challenges.filter.not_started": "No Iniciado",
  "challenges.filter.completed": "Completado",
  "challenges.filter.failed": "Fallido",
  "challenges.filter.locked": "Bloqueado",
  "challenges.filter.clear": "Limpiar todo",
  "challenges.filter.apply": "Aplicar filtros ({{ count }})",
};

const bootcamp = {
  "bootcamp.skip.confirmation.title": "¿Estás seguro?",
  "bootcamp.skip.confirmation.description":
    "Omitir el Bootcamp te llevará directamente a la experiencia principal. Podrás volver a estos desafíos más adelante.",
  "bootcamp.skip.confirmation.cancel": "Seguir entrenando",
  "bootcamp.skip.confirmation.confirm": "Omitir Bootcamp",
};

const challengeRewardScarcity = {
  "challenges.reward.scarcity.common": "Común",
  "challenges.reward.scarcity.uncommon": "Incomún",
  "challenges.reward.scarcity.rare": "Raro",
  "challenges.reward.scarcity.epic": "Épico",
  "challenges.reward.scarcity.legendary": "Legendario",
};

export default challengeCard;
export const challenges = {
  ...challengesList,
  ...challengeModal,
  ...challengeSection,
  ...challengesPage,
  ...challengePage,
  ...challengeStatus,
  ...challengeCategoryPage,
  ...challengeReward,
  ...challengeCard,
  ...challengeFilter,
  ...challengeRewardScarcity,
  ...bootcamp,
};
